<template>
    <div>
         <p class="bigTitle"><span class="floor">*</span>系统管理>账号设置</p>
         <div class="body">
             <el-form ref="form" class="form" :model="form" label-width="80px">
                 <p>个人信息</p>
                    <el-form-item label="昵称：">
                        <el-input class="input" v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="姓名：">
                        <el-input class="input" v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="账号：">
                        <el-input class="input" v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="部门：">
                        <el-input class="input" v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="手机：">
                        <el-input class="input" v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="座机：">
                        <el-input class="input" v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱：">
                        <el-input class="input" v-model="form.name"></el-input>
                    </el-form-item>
                <p>密码修改</p>
                    <el-form-item label="原密码：">
                        <el-input class="input" v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="新密码：">
                        <el-input class="input" v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="再确认：">
                        <el-input class="input" v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" class="buttom" @click="onSubmit">保存</el-button>
                    </el-form-item>
             </el-form>
         </div>
    </div>
</template>

<script>
export default {
    data() {
      return {
          form: {
          name: '',
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: ''
        }
      }
    },
    methods: {
    
  }
  };
</script>

<style scoped>

.bigTitle{
    text-align: left;
}

.floor{
    width: 15px;
    background-color: #0F86DA;
    color:#0F86DA;
    border-radius: 5px;
}

.body{
    background-color: #FFFFFF;
    border-radius: 10px;
}

.form{
    padding-top: 1%;
    padding-bottom: 1%;
}

.input{
    width: 20%;
    margin-right: 80%;
}

.buttom{
    margin-right: 80%;
}
</style>


// WEBPACK FOOTER //
// src/components/Hotel/product/setup/userName.vue